import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ClientsPage from './pages/ClientsPage';
import UsersPage from './pages/UsersPage';
import ProjectsPage from './pages/ProjectsPage';
import TasksPage from './pages/TasksPage';
import DocumentsPage from './pages/DocumentsPage';
import AuditsListPage from './pages/AuditsListPage';
import AuditDetailPage from './pages/AuditDetailPage';
import AppLayout from './components/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminOnlyRoute from './components/AdminOnlyRoute';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'clients',
        element: (
          <AdminOnlyRoute>
            <ClientsPage />
          </AdminOnlyRoute>
        ),
      },
      {
        path: 'users',
        element: (
          <AdminOnlyRoute>
            <UsersPage />
          </AdminOnlyRoute>
        ),
      },
      {
        path: 'projects',
        element: (
          <AdminOnlyRoute>
            <ProjectsPage />
          </AdminOnlyRoute>
        ),
      },
      {
        path: 'tasks',
        element: <TasksPage />,
      },
      {
        path: 'documents',
        element: <DocumentsPage />,
      },
      {
        path: 'audits',
        element: <AuditsListPage />,
      },
      {
        path: 'audits/:id',
        element: <AuditDetailPage />,
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
